import { render, staticRenderFns } from "./CatTableProp.vue?vue&type=template&id=63a36c73&scoped=true&"
import script from "./CatTableProp.vue?vue&type=script&lang=js&"
export * from "./CatTableProp.vue?vue&type=script&lang=js&"
import style0 from "./CatTableProp.vue?vue&type=style&index=0&id=63a36c73&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a36c73",
  null
  
)

export default component.exports